import React from 'react'
import './Footer.scss'

function Footer() {
    return (
        <div className='footer'>
            <div>Movie App</div>
            <div>© 2021, Inc. or its affliates</div>
        </div>
    )
}

export default Footer
